import PropTypes from "prop-types";
import React from "react";
import GuestbookToolTip from "./GuestbookTooltip";
import styled, { css } from "styled-components";
import { rem } from "polished";

const StyledInputWrapper = styled.div`
  font-family: ${({ theme }) => theme.secondaryFont};
  ${({ theme }) => theme.FontWithLineHeight("16px")};
  font-weight: 400;
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-end;

  ${({ theme }) => theme.mobileL`
    ${({ theme }) => theme.FontWithLineHeight("14px")};
  `}
`;

const StyledInput = styled(
  ({ component, isHotelLanding, borderBottomOnly, ...props }) =>
    React.cloneElement(component, props)
)`
  font-family: inherit;
  font-size: inherit;
  font-weight: 400;
  color: #343638;
  padding: ${rem("10px")} ${rem("15px")};
  border: ${rem("1px")} solid #cbcbcb;
  box-shadow: 0px ${rem("1px")} ${rem("10px")} #0000000d;
  border-radius: ${rem("2px")};
  background: #fff;

  ${({ borderBottomOnly }) =>
    borderBottomOnly == true &&
    css`
      border-top: 0;
      border-left: 0;
      border-right: 0;
      padding-left: 0;
      padding-right: 0;
    `};

  &:focus {
    outline-color: ${({ theme }) => theme.primaryColor};
  }

  &:focus::-webkit-input-placeholder {
    color: transparent;
  }
`;

const InputLabel = styled.label`
  font-family: ${({ theme }) => theme.secondaryFont};
  ${({ theme }) => theme.FontWithLineHeight("16px")};
  font-weight: 400;
  margin-bottom: 5px;
  color: ${(props) => (props.isErrorLabel ? "red" : "#666")};

  ${({ theme }) => theme.mobileL`
    ${({ theme }) => theme.FontWithLineHeight("14px")};
  `}
`;

const InputWrapper = ({
  id,
  labelText,
  isHotelLanding,
  tooltip,
  borderBottomOnly,
  isErrorLabel,
  children,
}) => {
  const label = labelText ? (
    <InputLabel htmlFor={id} isErrorLabel={isErrorLabel}>
      {labelText}
      {tooltip ? <GuestbookToolTip message={tooltip} /> : null}
    </InputLabel>
  ) : null;

  return (
    <StyledInputWrapper>
      {label}
      <StyledInput
        component={children}
        isHotelLanding={isHotelLanding}
        borderBottomOnly={borderBottomOnly}
      />
    </StyledInputWrapper>
  );
};

InputWrapper.propTypes = {
  /**
   * Specify a custom `id` for the <input>
   */
  id: PropTypes.string.isRequired,

  /**
   * Provide the text that will be read by a screen reader when visiting this
   * control
   */
  labelText: PropTypes.node,

  /**
   * Provide the text for the tooltip if it exists
   */
  tooltip: PropTypes.string,

  /**
   * Specify the input element
   */
  children: PropTypes.node,

  /**
   * Specify the whether this is on the hotel landing
   */
  isHotelLanding: PropTypes.bool,

  /**
   * Specify if input should be kosher or only have a border bottom
   */
  borderBottomOnly: PropTypes.bool,

  /**
   * Specify if label should be red (for error) or grey for default text
   */
  isErrorLabel: PropTypes.bool,
};

InputWrapper.defaultProps = {
  isHotelLanding: false,
  borderBottomOnly: false,
};

export { InputWrapper, InputLabel };
